// extracted by mini-css-extract-plugin
export default {"iconContainer":"sDOCxJgDBG"};